import React, { useCallback } from 'react';
import type { ReactNode } from 'react';
import { useEnrollment } from '../context';
import { useEnrollmentPolling } from '../hooks/use-enrollment-polling';
import { useWebAuthnRegistration } from '../hooks/use-webauthn-registration';
import { useEnrollmentAuthentication } from '../hooks/use-enrollment-authentication';
import {
  SpinnerContainer,
  Spinner,
  Container,
  Content,
  Title,
  Subtitle,
  AuthButton,
} from './polling-auth-screen.styles';

export function PollingAuthScreen(): ReactNode {
  const { data } = useEnrollment();
  const performWebAuthn = useWebAuthnRegistration();
  const submitAuthentication = useEnrollmentAuthentication();

  useEnrollmentPolling();

  const isPolling = data.state === 'POLLING';
  const isReady = data.state === 'READY_TO_AUTH';

  const handleAuthenticate = useCallback(async () => {
    if (!isReady) return;

    const credentialData = await performWebAuthn();
    if (credentialData) {
      await submitAuthentication(credentialData);
    }
  }, [isReady, performWebAuthn, submitAuthentication]);

  if (isPolling) {
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    );
  }

  return (
    <Container>
      <Content>
        <Title>Quase tudo pronto para concluir o vínculo.</Title>
        <Subtitle>Autentique para vincular sua conta.</Subtitle>

        <AuthButton onClick={handleAuthenticate}>
          Autenticar
        </AuthButton>
      </Content>
    </Container>
  );
}
